<template>
  <v-app light>
    <v-app-bar app :src="getBannerSrc()" :height="150" flat>
      <div class="slide-group-wrapper">
        <v-slide-group class="mt-0" v-model="menuCateGorySlideIndex" mandatory>
          <v-slide-item v-for="(item, key) of groupMenuCategory" :key="`slide-item-group-${key}`"
            v-slot:default="{ active, toggle }">
            <v-card v-if="groupMenus.length > 0" class="mr-1" flat @click="onGroupCategoryClick(item, toggle)"
              align="center">
              <v-img :src="item.image" :height="menuCategoryImageHeightWidth" :width="menuCategoryImageHeightWidth"
                :style="getMenuCategoryImageStyle(active)" contain />
              <v-card-text class="pt-0 pb-0 primary--text subtitle-1 font-weight-bold" align="center">
                {{ item.name[language] }}
              </v-card-text>
            </v-card>
          </v-slide-item>
          <v-slide-item v-for="(item, key) of menuCategory" :key="`slide-item-${key}`"
            v-slot:default="{ active, toggle }">
            <v-card @click="onCategoryClick(item, toggle)" class="mr-1" align="center" flat>
              <v-img :src="item.image" :height="menuCategoryImageHeightWidth" :width="menuCategoryImageHeightWidth"
                :style="getMenuCategoryImageStyle(active)" contain />
              <v-card-text class="pt-0 primary--text subtitle-1 font-weight-bold">
                {{ item.name[language] }}
              </v-card-text>
            </v-card>
          </v-slide-item>
        </v-slide-group>
      </div>
    </v-app-bar>
    <v-content>
      <v-card flat>
        <v-container v-show="showGroup" fluid>
          <v-list two-line>
            <v-list-item v-for="(item, key) of showGroupMenus" :key="`group-menu-item-${key}`"
              @click="exploreGroupMenu(item)" :disabled="item.isSoldOut === 'Y'">
              <v-list-item-avatar horizontal height="60" width="60">
                <v-img :src="getMenuImgSrc(item.productGroupMedia)">
                </v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="title font-weight-bold" v-html="(language === 'en_US')
                  ? item.productGroupEnglishName
                  : item.productGroupName" />
                <v-list-item-subtitle v-if="item.isSoldOut === 'Y'" class="error--text headline font-weight-bold"
                  v-html="`${labels.soldOut[language]}`" />
                <v-list-item-subtitle v-else class="primary--text headline font-weight-bold"
                  v-html="`$ ${item.productGroupPrice} ${labels.up[language]}`" />
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-container>
        <v-container v-show="!showGroup" fluid>
          <v-list two-line>
            <v-list-item v-for="(item, key) of showMenus" :key="`menu-item-${key}`" @click="exploreMenu(item)"
              :disabled="item.isSoldOut === 'Y'">
              <v-list-item-avatar horizontal height="60" width="60">
                <v-img :src="getMenuImgSrc(item.productMedia)">
                </v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="title font-weight-bold" v-html="(language === 'en_US')
                  ? item.productEnglishName
                  : item.productName" />
                <v-list-item-subtitle v-if="item.isSoldOut === 'Y'" class="error--text headline font-weight-bold"
                  v-html="`${labels.soldOut[language]}`" />
                <v-list-item-subtitle v-else class="primary--text headline font-weight-bold"
                  v-html="`$ ${item.productPrice}`"></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-container>
      </v-card>
    </v-content>
    <v-footer v-show="!bottomSheet" class="pa-0" app>
      <v-btn height="40" class="title font-weight-bold" color="primary" @click="bottomSheet = true" block depressed>
        {{ `${labels.orders[language]} ${tableName}` }}
      </v-btn>
    </v-footer>
    <v-bottom-sheet v-model="bottomSheet">
      <v-sheet>
        <v-container class="pa-0" fluid>
          <v-row class="pa-0">
            <v-col>
              <v-simple-table height="400" fixed-header>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th colspan="4" class="primary ma-0 font-weight-black subtitle-1 text-left white--text"
                        style="height: 26px">
                        {{ labels.orders[language] }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in orderItems" :key="`${item.productId}-${index}-1`">
                      <td width="50%" class="subtitle pa-3 pl-6">{{
                        getListProductName(item)
                        }}
                      </td>
                      <td width="15%" class="subtitle pa-3">{{
                        calculateOrderItemPrice(item)
                        }}
                      </td>
                      <td>
                        {{ item.count }}
                      </td>
                      <td width="20%">
                        <v-btn color="primary" @click="deleteOrderItem(item)" small block outlined>
                          {{ labels.cancel[language] }}
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-container>
        <v-container class="pa-0" fluid>
          <v-row class="pa-0">
            <v-col class="pr-0 pl-0" xs="4">
              <v-btn class="subtitle-1 font-weight-bold" color="primary" @click="bottomSheet = false" block depressed>
                {{ labels.another[language] }}
              </v-btn>
            </v-col>
            <v-col class="pr-0 pl-0" xs="4">
              <v-btn class="subtitle-1 font-weight-bold" color="primary" @click="goHome" block outlined>
                {{ labels.cancelAll[language] }}
              </v-btn>
            </v-col>
            <v-col class="pr-0 pl-0" xs="4">
              <v-btn class="subtitle-1 font-weight-bold" color="primary" @click="goNext" block depressed
                :disabled="this.totalAmount === 0">
                {{ labels.checkout[language] }} {{
                  (totalAmount !== 0
                    ? `( $${totalAmount} )` : '')
                }}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>
    <menu-dialog :dialog="dialogMenu" :menuItem="dialogMenuItem" @onDialogClose="handleDialogClose"></menu-dialog>
    <group-menu-dialog :dialog="dialogGroupMenu" :menuItem="dialogMenuItem"
      @onDialogClose="handleDialogClose"></group-menu-dialog>
  </v-app>
</template>
<script>
import MenuDialog from './MenuDialog.vue'; //eslint-disable-line
import GroupMenuDialog from './GroupMenuDialog.vue'; //eslint-disable-line
import { deepCopy } from '../assets/functions/deepCopy';

const additionalIndex = [1, 2, 3, 4, 5];
const base64Encode = (str) => Buffer.from(str, 'utf-8').toString('base64');

export default {
  name: 'MainPage',
  components: {
    MenuDialog,
    GroupMenuDialog,
  },
  props: {},
  data: () => ({
    labels: {
      orders: {
        en_US: 'ORDER',
        zh_TW: '我的訂單',
      },
      another: {
        en_US: 'ANOTHER',
        zh_TW: '繼續點餐',
      },
      cancelAll: {
        en_US: 'CANCEL ALL',
        zh_TW: '取消訂單',
      },
      cancel: {
        en_US: 'CANCEL',
        zh_TW: '取消',
      },
      checkout: {
        en_US: 'CHECKOUT',
        // zh_TW: '結帳',
        zh_TW: '確認',
      },
      up: {
        en_US: 'UP',
        zh_TW: '起',
      },
      soldOut: {
        en_US: 'SOLD OUT',
        zh_TW: '售完',
      },
    },
    menus: [],
    groupMenus: [],
    devices: [],
    printers: [],
    dialogMenu: false,
    dialogGroupMenu: false,
    dialogMenuItem: {},
    menuCategory: [],
    groupMenuCategory: [],
    showMenuCategoryId: '',
    showGroupMenuCategoryId: '',
    showGroup: true,
    menuCateGorySlideIndex: 0,
    bottomSheet: false,
  }),
  methods: {
    getBannerSrc() {
      const setting = this.$store.getters.storeSetting;
      if (setting.kioskHomePageBanner) {
        return setting.kioskHomePageBanner.url + setting.kioskHomePageBanner.file_name;
      }
      return '';
    },
    getMenuImgSrc(productMedia) {
      try {
        // const img = require(`../assets/${productMedia.url}/${productMedia.file_name}`);
        const img = `${productMedia.url}/${productMedia.file_thumb}`;
        return img;
      } catch {
        return '';
      }
    },
    exploreMenu(item) {
      // find additional products
      const additional = this.$store.getters.additionalProductInfo.filter((p) => {
        const _parentIds = p.parentProductId.split(',');
        return _parentIds.indexOf(item.productId) > -1;
      });

      this.dialogMenuItem = {
        ...item,
        additional,
      };
      this.dialogMenu = true;
    },
    exploreGroupMenu(item) {
      this.dialogMenuItem = { ...item };
      this.dialogGroupMenu = true;
    },
    handleDialogClose(selectedItems) {
      this.dialogMenu = false;
      this.dialogGroupMenu = false;

      selectedItems.forEach((selectedItem) => {
        const _sItem = { ...selectedItem };

        // 單點 要把不必要的訊息移除
        if ((!_sItem.isGroup) && _sItem.productId) {
          delete _sItem.additional;
        }

        if (_sItem.isGroup || _sItem.productId) {
          this.orderItems = _sItem;
        }
      });
      this.dialogMenuItem = {}; // reset
      if (this.orderItems.length) this.bottomSheet = true; // 開啟底部表單
    },
    onGroupCategoryClick(cate, callback) {
      this.menuPage = 1;
      this.showGroupMenuCategoryId = cate.id;
      this.showGroup = true;
      if (callback) callback();
    },
    onCategoryClick(cate, callback) {
      if (cate.id) {
        this.showMenuCategoryId = cate.id;
        this.showGroup = false;
        if (callback) callback();
      }
    },
    setCategoryInfo(posProductTypeInfo) {
      const menuCategories = ['menuCategory', 'groupMenuCategory'];
      let defaultCategoryId;
      let defaultIsGroup = false;
      let defaultSlideIndex = 0;

      menuCategories.forEach((mCate) => {
        const _cateItem = [];
        let _count = 0;
        posProductTypeInfo.forEach((info) => {
          const {
            productTypeId,
            productTypeName,
            productTypeEnglishName,
            isGroup,
            productTypeImage,
            productTypeOrder,
          } = info;

          if (productTypeImage) { // show this category only if it has icon image.
            // 確認類別名稱有沒有含有內用或外帶的字，如果跟現況不合的就不出現
            if (!this.checkProductType(productTypeEnglishName)) {
              return;
            }
            const _group = (mCate === 'groupMenuCategory') ? 'Y' : 'N';
            if (isGroup === _group) {
              _cateItem.push({
                id: productTypeId,
                name: {
                  zh_TW: productTypeName,
                  en_US: productTypeEnglishName.split('#')[0], // 有的品名英文名稱有加#當註記
                },
                image: productTypeImage.url + productTypeImage.file_name,
              });
              // set default category if type order is '0'
              if (productTypeOrder === '0') {
                defaultCategoryId = productTypeId;
                defaultIsGroup = (_group === 'Y');
                defaultSlideIndex = _count;
              }
              _count += 1;
            }
          }
        });
        this[mCate] = _cateItem;
      });
      // set default category
      if (this.groupMenuCategory.length) {
        if (defaultCategoryId && defaultIsGroup) {
          this.showGroupMenuCategoryId = defaultCategoryId;
          this.menuCateGorySlideIndex = defaultSlideIndex;
        } else {
          this.showGroupMenuCategoryId = this.groupMenuCategory[0].id;
        }
        this.showGroup = true;
        return;
      }
      if (this.menuCategory.length) {
        if (defaultCategoryId && !defaultIsGroup) {
          this.showMenuCategoryId = defaultCategoryId;
          this.menuCateGorySlideIndex = this.groupMenuCategory.length + defaultSlideIndex;
        } else {
          this.showMenuCategoryId = this.menuCategory[0].id;
        }
        this.showGroup = false;
      }
    },
    goHome() {
      const {
        no,
        extPos,
        skipBeforeOrder,
        orderNo,
        tableIndexNo,
        people,
      } = this.$store.getters;
      this.$store.dispatch('cleanOrder');
      let homeUrl = `/?no=${base64Encode(no)}`;
      if (extPos && extPos.ext) {
        homeUrl += `&ext=${base64Encode(extPos.ext)}`;
      }
      if (skipBeforeOrder) {
        homeUrl += '&skip=true';
      }
      if (orderNo.length > 0) {
        homeUrl += `&order=${base64Encode(orderNo)}`;
      }
      if (tableIndexNo.length > 0) {
        homeUrl += `&tableIndex=${tableIndexNo}`;
      }
      if (people === true) {
        homeUrl += '&people=true';
      }
      this.$router.replace(homeUrl);
    },
    deleteOrderItem(item) {
      this.$store.dispatch('deleteOrderItem', item.indexs);
    },
    goNext() {
      const next = this.$store.getters.nextStatusText;
      this.$router.push(next);
    },
    calculateOrderItemPrice(item) {
      if (item.isGroup) {
        return item.groupAmounts.reduce((accu, curr) => accu + curr, 0);
      }
      const additionalTotal = additionalIndex.reduce((subAccu, subCurr) => {
        let _price = 0;
        const _additionalItems = item[`additionalOfProduct${subCurr}`];
        if (_additionalItems && _additionalItems.products) {
          _additionalItems.products.forEach((_item) => {
            if (_item.productPrice) _price += parseInt(_item.productPrice, 10);
          });
        }
        return subAccu + _price;
      }, 0);
      return parseInt(item.productPrice, 10) + additionalTotal;
    },
    getItemProductName(item) {
      return (this.language === 'en_US') ? item.productEnglishName : item.productName;
    },
    getListProductName(item) {
      if (item.isGroup) {
        return (this.language === 'en_US')
          ? item.groupMainItem.productGroupEnglishName
          : item.groupMainItem.productGroupName;
      }
      return this.getItemProductName(item);
    },
    getMenuCategoryImageStyle(active) {
      if (active) {
        return `margin:6px 6px 0 6px;border:2px solid ${this.$vuetify.theme.themes.light.primary};border-radius: 10%`;
      }
      return '';
    },
    getListNotice(item) {
      if (item.isGroup) {
        return item.groupSelectedItem.reduce((accu, curr) => {
          const _name = (this.language === 'en_US') ? curr.productEnglishName : curr.productName;
          return `${accu}+${_name}`;
        }, '');
      }
      return additionalIndex.reduce((accu, curr) => {
        const additionalItems = item[`additionalOfProduct${curr}`];
        if (additionalItems && additionalItems.products) {
          const _addName = additionalItems.products.reduce((_accu, _curr) => {
            const _name = (this.language === 'en_US') ? _curr.productEnglishName : _curr.productName;
            return `${_accu} + ${_name}`;
          }, '');
          return `${accu} ${_addName}`;
        }
        return accu;
      }, '');
    },
    checkProductType(productTypeEnglishName) {
      const { diningIn } = this.$store.getters;
      let regex;
      if (diningIn === 'for-here') {
        regex = new RegExp('TAKEOUT');
      }
      if (diningIn === 'to-go') {
        regex = new RegExp('HERE');
      }
      if (diningIn === 'delivery') {
        regex = new RegExp('DELIVERY');
      }
      if (regex?.test(productTypeEnglishName)) return false;
      return true;
    },
  },
  created() {
    // 取得設定檔
    // 本地菜單分類
    // this.menuCategory = config['menu-category']['single-items'];
    // this.groupMenuCategory = config['menu-category'].sets;
    this.menus = this.$store.getters.menus;
    this.groupMenus = this.$store.getters.groupMenus;
    this.devices = this.$store.getters.devices;
    this.setCategoryInfo(this.$store.getters.category);
    this.$store.dispatch('setOrderContent',
      { storeName: this.$store.getters.storeSetting.storeName });
  },
  mounted() {
    this.$store.dispatch('setStatus', 'ORDER');
    const { previousOrder } = this.$store.getters;
    if (previousOrder.length > 0) {
      this.labels.orders.zh_TW = '我的加點訂單';
    }
  },
  computed: {
    tableName() {
      const { order, tableInfo } = this.$store.getters;
      let result = '';
      if (order.tableId) {
        tableInfo.forEach((item) => {
          if (order.tableId === item.tableId) {
            result = item.tableName;
          }
        });
      }
      if (result.length > 0) {
        result = `（${result}）`;
      }
      return result;
    },
    language() {
      return this.$store.getters.language;
    },
    showMenus: {
      get() {
        if (this.menus) {
          return this.menus.filter((menu) => menu.isShowInOnlineOrder === 'Y' && menu.isHideInSingleProduct === 'N'
            && menu.productTypeId === this.showMenuCategoryId);
        }
        return [];
      },
    },
    showGroupMenus: {
      get() {
        if (this.groupMenus) {
          return this.groupMenus
            .filter((menu) => menu.isShowInOnlineOrder === 'Y' && menu.productGroupTypeId === this.showGroupMenuCategoryId);
        }
        return [];
      },
    },
    orderItems: {
      get() {
        const result = [];
        const items = deepCopy(this.$store.getters.orderItems);
        const alacarte = {}; // 單點
        items.forEach((item, index) => {
          if (item?.isGroup === true) {
            item.indexs = [index];
            item.count = 1;
            result.push(item);
          } else {
            let keyName = item.productName;
            const additionArr = [];
            for (let i = 1; i <= 5; i += 1) {
              const addition = item[`additionalOfProduct${i}`];
              if (addition !== null) { // 一定是 object，可以放心遞迴或做物件處理
                additionArr.push(addition);
              }
            }
            additionArr.sort((a, b) => a.productTypeName.localeCompare(b.productTypeName));
            additionArr.forEach((additionItem) => {
              additionItem.products.sort((a, b) => a.productName.localeCompare(b.productName));
            });
            additionArr.forEach((additionItem) => {
              keyName += additionItem.productTypeName;
              additionItem.products.forEach((product) => {
                keyName += product.productName;
              });
            });
            if (!alacarte[keyName]) {
              alacarte[keyName] = { product: {}, indexs: [] };
              alacarte[keyName].product = deepCopy(item);
              alacarte[keyName].indexs.push(index);
            } else {
              alacarte[keyName].indexs.push(index);
            }
            // const { productId } = item;
            // if (!alacarte[productId]) {
            //   alacarte[productId] = { product: {}, indexs: [] };
            //   alacarte[productId].product = deepCopy(item);
            //   alacarte[productId].indexs.push(index);
            // } else {
            //   alacarte[productId].indexs.push(index);
            // }
          }
        });
        // eslint-disable-next-line guard-for-in, prefer-const, no-restricted-syntax
        for (let key in alacarte) {
          const data = alacarte[key].product;
          data.indexs = alacarte[key].indexs;
          data.count = alacarte[key].indexs.length;
          result.push(data);
        }
        result.reverse();
        return result;
      },
      set(value) {
        this.$store.dispatch('setOrderItem', value);
      },
    },
    totalAmount: {
      get() {
        return this.$store.getters.totalAmount;
      },
    },
    bannerImageHeight: {
      get() {
        if (this.$vuetify.breakpoint.name === 'xs') {
          return '120';
        }
        return '240';
      },
    },
    menuCategoryImageHeightWidth: {
      get() {
        if (this.$vuetify.breakpoint.name === 'xs') {
          return '70';
        }
        return '100';
      },
    },
  },
};
</script>
<style scoped>
.slide-group-wrapper {
  overflow-x: auto;
  overflow-y: hidden;
  /* 阻止垂直滾動 */
  -webkit-overflow-scrolling: touch;
  /* 保持平滑滑動 */
  touch-action: pan-x;
  /* 優先水平滑動 */
}
</style>
